'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDonutSmall = function MdDonutSmall(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 24.8c1.7-0.5 2.6-1.8 3.2-3.2h11.8c-0.7 7.9-6.6 14.3-15 15v-11.8z m3.2-6.4c-0.6-1.4-1.5-2.7-3.2-3.2v-11.8c8.4 0.7 14.3 7.1 15 15h-11.8z m-6.4-3.2c-1.7 0.7-3.4 2.6-3.4 4.8s1.7 4.1 3.4 4.8v11.8c-8.4-0.8-15-7.9-15-16.6s6.6-15.8 15-16.6v11.8z' })
        )
    );
};

exports.default = MdDonutSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/donut-small.js
// module id = 1394
// module chunks = 168707334958949